import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { CALYPSO_LIGHT, CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../../experiments/useExperiment';
import { Tracker } from '../../store/tracking/action-creators';
import { StyledUILink } from '../TextInput.styles';
const FeaturesLink = styled(StyledUILink).withConfig({
  displayName: "GuaranteeBannerFeaturesLink__FeaturesLink",
  componentId: "sc-1joglgv-0"
})(["color:", ";&:hover{color:", ";}"], CALYPSO_LIGHT, CALYPSO_MEDIUM);
const LinkContainer = styled.div.withConfig({
  displayName: "GuaranteeBannerFeaturesLink__LinkContainer",
  componentId: "sc-1joglgv-1"
})(["padding-top:20px;padding-bottom:20px;z-index:1;"]);
export const GuaranteeBannerFeaturesLink = () => {
  const {
    parameter: acq117Parameter
  } = useExperiment(ExperimentKeys.ACQ117, TrackWhen.never);
  const dispatch = useDispatch();

  const redirectToPage = () => {
    dispatch(Tracker.signupInteraction(`acq117-${acq117Parameter}-click-open-features-link`));
    window.open('https://www.hubspot.com/pricing/crm', '_blank');
  };

  return /*#__PURE__*/_jsx(LinkContainer, {
    children: /*#__PURE__*/_jsxs(FeaturesLink, {
      color: CALYPSO_LIGHT,
      onClick: () => {
        redirectToPage();
      },
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: 'guaranteeBanner.featuresLink'
      }), /*#__PURE__*/_jsx(UIIcon, {
        className: "m-left-2",
        color: CALYPSO_LIGHT,
        name: "externalLink"
      })]
    })
  });
};